<template>
  <!-- <div id="app"> -->
    <v-app style="background-color: #ffffff;">
      <!-- <div id="content-container" fluid> -->
        <Header />
          <v-content class="v-content-container" id="content-container">
            <transition name="slide" mode="out-in">
              <router-view/>
            </transition>
          </v-content>
        <Footer id="footer"/>
      <!-- </div> -->

      <!-- <v-container>
        <v-layout style="height: 100%;">
          <v-flex id="flex-container">
          </v-flex>
        </v-layout>
      </v-container> -->
    </v-app>
  <!-- </div> -->
</template>

<script>
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import '../node_modules/slick-carousel/slick/slick.css'
import '../node_modules/slick-carousel/slick/slick-theme.css'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  watch: {
    contentContainer () {
      console.log(this.contentContainer)
    }
  },
  computed: {
    contentContainer () {
      return document.querySelector('#content-container').clientHeight
    }
  },
  methods: {
    observeHeight () {
      const contentContainer = document.querySelector('#content-container')
      const resizeObserver = new ResizeObserver(function () {
        // console.log(`observe height: ${contentContainer.clientHeight}`)

        const headerHeight = document.querySelector('#header-navbar').clientHeight
        const footerHeight = document.querySelector('.v-footer').clientHeight
        const totalHeight = headerHeight + contentContainer.clientHeight + footerHeight

        const windowHeight = window.innerHeight
        // console.log(`missing: ${windowHeight - totalHeight}`)

        const missingHeight = windowHeight - totalHeight

        if (missingHeight > 0) {
          contentContainer.style.minHeight = contentContainer.clientHeight + missingHeight + 'px'
        }
      })

      // resizeObserver.observe(document.getElementById('content-container'))
      resizeObserver.observe(contentContainer)
    }
  },
  mounted () {
    // const container = document.querySelector('#content-container')
    // console.log(container.clientHeight)
    // console.log(window.innerHeight)

    this.observeHeight()

    // const homeContainer = document.querySelector('#home-container')
    // console.log(homeContainer.clientHeight)

    // if (container.clientHeight > homeContainer.clientHeight) {
    //   container.style.maxHeight = homeContainer.clientHeight + 'px'
    // }
    // if (container.clientHeight < homeContainer.clientHeight) {
    //   homeContainer.style.height = container.clientHeight + 'px'
    // }

    const applicationWrap = document.querySelector('.application--wrap')
    applicationWrap.style.minHeight = '0'
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  // background: url('assets/Background.png') center/cover no-repeat border-box;
}

@font-face {
  font-family: 'open-sans-bold';
  src: url('assets/font/OpenSans-Bold.ttf');
}

@font-face {
  font-family: 'open-sans-semibold';
  src: url('assets/font/OpenSans-SemiBold.ttf');
}

@font-face {
  font-family: 'open-sans-extrabold';
  src: url('assets/font/OpenSans-ExtraBold.ttf');
}

.application--wrap {
  max-height: 100vh;
}

.v-content-container {
  // display: grid !important;
  // align-content: center;
}

// #flex-container {
//   display: grid;
//   grid-template-rows: 1fr auto 1fr;
// }

// out of v-container; under v-app only
// #content-container {
//   height: 100%;
//   display: grid;
//   grid-template-rows: 1fr auto 1fr;
//   grid-template-columns: 1fr;
// }

#footer {
  align-self: end;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  width: 100%;
}

@keyframes slide-in {
  from {
      transform: translateY(-30px);
      opacity: 0;
  }
  to {
      transform: translateY(0);
      opacity: 1;
  }
}

@keyframes slide-out {
  from {
      transform: translateY(0);
      opacity: 1;
  }
  to {
      transform: translateY(-30px);
      opacity: 0;
  }
}
</style>
